/* eslint-disable */
import { getLocale, experimentalStaticLocale } from '../runtime.js';

/** @typedef {import('../runtime.js').LocalizedString} LocalizedString */

/** @typedef {{}} Settings_Keys_TitleInputs */

const en_settings_keys_title = /** @type {(inputs: Settings_Keys_TitleInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`API keys`)
};

const id_settings_keys_title = /** @type {(inputs: Settings_Keys_TitleInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`API key`)
};

/**
* | output |
* | --- |
* | "API keys" |
*
* @param {Settings_Keys_TitleInputs} inputs
* @param {{ locale?: "en" | "id" }} options
* @returns {LocalizedString}
*/
export const settings_keys_title = /** @type {((inputs?: Settings_Keys_TitleInputs, options?: { locale?: "en" | "id" }) => LocalizedString) & import('../runtime.js').MessageMetadata<Settings_Keys_TitleInputs, { locale?: "en" | "id" }, {}>} */ ((inputs = {}, options = {}) => {
	const locale = experimentalStaticLocale ?? options.locale ?? getLocale()
	if (locale === "id") return id_settings_keys_title(inputs)
	return en_settings_keys_title(inputs)
});